import React from "react"

const IconLegalAndDocumental = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <path
        stroke="#3A589B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M18.668 13.064l-12.81.925c-1.72.124-3.19-1.101-3.19-2.659 0-1.555 1.47-2.78 3.19-2.657l12.81.926"
      ></path>
      <path
        stroke="#3A589B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M28 18.664H17.335M28 3.997H17.335M16 28.003h13.331m-11.697 0c.734-1.318 1.284-3.836 3.886-3.978.774-.042 1.56-.042 2.334 0 2.601.142 3.153 2.66 3.889 3.978M26.668 3.997h-8s-.667 3.95-.667 7.334c0 3.385.667 7.333.667 7.333h8s.667-3.948.667-7.333c0-3.384-.667-7.334-.667-7.334z"
      ></path>
    </svg>
  )
}

export default IconLegalAndDocumental
